// import firebase from 'firebase';
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import "firebase/compat/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyBcUAZ9_tPcIXWhZjugaEphTagDo5FNo_k",
    authDomain: "clone-73626.firebaseapp.com",
    projectId: "clone-73626",
    storageBucket: "clone-73626.appspot.com",
    messagingSenderId: "121383106884",
    appId: "1:121383106884:web:c16470c058029afdd9bf11",
    measurementId: "G-VXYC0S0TZ5"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
 

  export { db, auth};